import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Footer from '@/components/Footer';
import PrefetchOnIdle from '@/components/PrefetchOnIdle';
import ServiceWorkerRegister from '@/components/ServiceWorkerRegister';
import PerformanceMonitor from '@/components/PerformanceMonitor';
import CookieConsent from '@/components/CookieConsent';

type RootLayoutProps = {
  children: React.ReactNode;
};

const RootLayout = ({ children }: RootLayoutProps) => {
  const location = useLocation();

  // Effect to scroll to top when route changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div className="min-h-screen bg-white w-full max-w-[100vw] overflow-x-hidden flex flex-col">
      <a 
        href="#main-content" 
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-brand-blue focus:text-white focus:rounded-md focus:outline-none focus:ring-2 focus:ring-brand-blue focus:ring-offset-2"
      >
        Skip to main content
      </a>
      <ServiceWorkerRegister />
      <PerformanceMonitor />
      <CookieConsent />
      <PrefetchOnIdle
        images={[
          { src: '/hero_homepage.jpg', width: 1200 }
        ]}
        priority="low"
      />
      <main id="main-content" className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default RootLayout;